import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { IDataType } from '../types/misc';

const initialState: {
  job_types: IDataType[];
  update: boolean;
  loading: boolean;
} = {
  job_types: [],
  update: false,
  loading: false
};

export const job_type = createSlice({
  name: 'job_type',
  initialState,
  reducers: {
    setJobTypes: (state, action: PayloadAction<IDataType[]>) => {
      state.job_types = action.payload;
    },
    createJobType: (state, action: PayloadAction<IDataType>) => {
      state.job_types = [action.payload, ...state.job_types];
    },
    updateJobType: (state, action: PayloadAction<IDataType>) => {
      state.job_types = state.job_types.map((item) => {
        if (item.id === action.payload.id) return action.payload;
        return item;
      });
    },
    setLoading: (state) => {
      state.loading = !state.loading;
    },
    setUpdate: (state) => {
      state.update = !state.update;
    }
  }
});

export const {
  setJobTypes,
  createJobType,
  updateJobType,
  setLoading,
  setUpdate
} = job_type.actions;

export default job_type.reducer;
